import eventEmitter from 'events'

export const eventBus = new eventEmitter.EventEmitter()
